export enum CalloutColor {
  LIGHT = 'light',
  DARK = 'dark',
}
